/* tslint:disable */
/* eslint-disable */
/**
 * quarkus-betting API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.36.47
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface TournamentGroup
 */
export interface TournamentGroup {
    /**
     * 
     * @type {number}
     * @memberof TournamentGroup
     */
    id?: number;
    /**
     * 
     * @type {string}
     * @memberof TournamentGroup
     */
    name?: string;
    /**
     * 
     * @type {string}
     * @memberof TournamentGroup
     */
    longName?: string;
    /**
     * 
     * @type {number}
     * @memberof TournamentGroup
     */
    order?: number;
}

/**
 * Check if a given object implements the TournamentGroup interface.
 */
export function instanceOfTournamentGroup(value: object): value is TournamentGroup {
    return true;
}

export function TournamentGroupFromJSON(json: any): TournamentGroup {
    return TournamentGroupFromJSONTyped(json, false);
}

export function TournamentGroupFromJSONTyped(json: any, ignoreDiscriminator: boolean): TournamentGroup {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'] == null ? undefined : json['id'],
        'name': json['name'] == null ? undefined : json['name'],
        'longName': json['longName'] == null ? undefined : json['longName'],
        'order': json['order'] == null ? undefined : json['order'],
    };
}

export function TournamentGroupToJSON(value?: TournamentGroup | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'id': value['id'],
        'name': value['name'],
        'longName': value['longName'],
        'order': value['order'],
    };
}

